import { App } from '../App';
import {
  DASHBOARD_URL,
  IS_VIVUS,
  IS_VIVUS_ONLINE,
  MOBILE_APP_GUEST,
} from 'utils/constants';
import { Response as GetApplicationResponse } from '../api/typegen/client/application/get';
import { getClientProductNumber } from '../utils/getProductNumber';
import { Response as GetClientResponse } from '../api/typegen/client/get';
import { isInWebView } from '../utils/isInWebView';
import { useCallback } from 'react';

export type CrossLoginRedirectTo = 'dashboard' | 'vivusonline' | 'vivus';

function useCrossDomainLoginRedirect() {
  const { fetch: oneTimeTokenFetch } = App.useApi(
    'client/security/one-time-token',
    'POST',
  );
  /** Log in user in dashboard app */
  const crossDomainLoginRedirect = useCallback(
    async (to: CrossLoginRedirectTo = 'dashboard', getUrl?: boolean) => {
      try {
        let baseUrl;
        switch (to) {
          case 'vivusonline':
            baseUrl = process.env.REACT_APP_VIVUSONLINE_URL;
            break;
          case 'vivus':
            baseUrl = process.env.REACT_APP_VIVUS_URL;
            break;
          default:
            baseUrl = isInWebView() ? MOBILE_APP_GUEST : DASHBOARD_URL;
        }

        const queryString = window.location.search
          ? `&${window.location.search.substring(1)}`
          : '';

        const { oneTimeToken } = await oneTimeTokenFetch();

        const redirectURL = `${baseUrl}/one-time-token-login?token=${oneTimeToken}${queryString}`;
        if (getUrl) return redirectURL;
        else {
          sessionStorage.clear();
          window.location.assign(redirectURL);
        }
      } catch (e) {}
    },
    [oneTimeTokenFetch],
  );

  const maybeRedirectCrossDomain = useCallback(
    (
      client: GetClientResponse | undefined,
      application: GetApplicationResponse | undefined | null,
    ) => {
      if (client?.status === 'IDENTIFIED') {
        crossDomainLoginRedirect('dashboard');
        return true;
      }

      const clientProductNumber =
        application?.status === 'OPEN'
          ? application.productNumber
          : getClientProductNumber(client?.availableProducts);

      if (IS_VIVUS && clientProductNumber === '6') {
        crossDomainLoginRedirect('vivusonline');
        return true;
      } else if (IS_VIVUS_ONLINE && clientProductNumber !== '6') {
        crossDomainLoginRedirect('vivus');
        return true;
      }
    },
    [crossDomainLoginRedirect],
  );

  return {
    crossDomainLoginRedirect,
    maybeRedirectCrossDomain,
  };
}

export default useCrossDomainLoginRedirect;
